export default __webpack_public_path__ + "static/media/watermark.b6e76807.png";